import { createContext } from 'react';

/**
 * Internal context — consumed only by `useConfirm`. Go through the hook
 * rather than importing this directly.
 */
export const ConfirmContext = createContext(null);

export default ConfirmContext;
